import {differenceInCalendarDays, parseISO, startOfDay} from "date-fns";
import {compile} from "path-to-regexp";

import {apiDateRegex} from "../../../../../utils/dates";
import {chartsRoutes} from "../../../common/app/routing/charts_routes";
import {EntryType, IEntry} from "../../newshub/types/Entry";
import {resolveNewshubMediaUrl} from "../../newshub/utils/resolve_newshub_media_url";

export const getArticlePath = (article: IEntry, language: string) => {
    const routes = chartsRoutes[language];

    if (article.type === EntryType.ARTICLE) {
        return compile(routes.newshub.marketInformation.details)({
            newsId: String(article.id),
            slug: article.slug
        });
    }
    if (article.type === EntryType.BIG_DATA_NEWS) {
        return compile(routes.newshub.bigDataNews.details)({
            newsId: String(article.id),
            slug: article.slug
        });
    }
    if (article.type === EntryType.PRESS_INFORMATION) {
        return compile(routes.pressOffice.pressInformation.details)({
            newsId: String(article.id),
            slug: article.slug
        });
    }
    if (article.type === EntryType.PRESS_REVIEW) {
        return compile(routes.pressOffice.pressReview.details)({
            newsId: String(article.id),
            slug: article.slug
        });
    }

    throw new Error("Unknown entry type");
};

const NEW_ARTICLE_MAX_AGE_DAYS = 7;

export const isArticleNew = (publicationDate: string) => {
    if (!publicationDate || !apiDateRegex.test(publicationDate)) {
        return false;
    }

    const published = startOfDay(parseISO(publicationDate));
    const today = startOfDay(new Date());
    const ageInDays = differenceInCalendarDays(today, published);

    return ageInDays >= 0 && ageInDays <= NEW_ARTICLE_MAX_AGE_DAYS;
};

export const getArticleMetaItems = (article: IEntry) => {
    const categoryNames = article.category?.map(({name}) => name) ?? [];

    return [article.publication_date, ...categoryNames].filter(Boolean);
};

/**
 * Hero landing – slot to połowa szerokości sekcji, czyli 957.5x705 (aspect 1.358), a img_1916x1410 (1.359) jest
 * jego dokładnym 2x. Crop względem okładek w 1.6 zjada biały margines, nie treść. Dalej rodzina 1.6, potem resztki.
 */
export const getEntryHeroImageUrl = (article: IEntry | undefined): string | null => {
    if (!article?.images) {
        return null;
    }

    const {img_1916x1410, img_840x523, img_744x463, img_430x268, img_332x208, img_1367x573, img_600x300, img_385x193} =
        article.images;

    const path =
        img_1916x1410 ||
        img_840x523 ||
        img_744x463 ||
        img_430x268 ||
        img_332x208 ||
        img_1367x573 ||
        img_600x300 ||
        img_385x193 ||
        null;

    return path ? resolveNewshubMediaUrl(path) : null;
};
